import React, { useState, useEffect, useCallback } from "react";
import 'chart.js';
import { Line } from "react-chartjs-2";
import { addDays } from "date-fns";
import {
  ChartWrapper,
  ReportWrapper,
  ChartTitle,
  Subtitle,
  DatepickerRow,
} from "./styles";
import CustomDatePicker from "./datepicker";
import { formatDate } from "./utils";
import { useQueryReport } from "../hooks/useQueryReport";
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";

const DayVisitsReport = (props) => {
  const INITIAL_STATE = {
    labels: [],
    values: [],
  };
  const [reportData, setReportData] = useState(INITIAL_STATE);
  const [startDate, setStartDate] = useState(addDays(new Date(), -10));
  const [endDate, setEndDate] = useState(new Date());
  const [average, setAverage] = useState(0);

  const { fetchData } = useQueryReport();

  const displayResults = useCallback((response) => {
    const queryResult = response.reports[0].rows;
    // const total = response.reports[0].data.totals[0].values[0];
    // setAverage(parseInt(total / response.reports[0].data.rowCount));
    let labels = [];
    let values = [];
    queryResult.forEach((row) => {

      labels.push(formatDate(row.dimensionValues[0].value));
      values.push(row.metricValues[0].value[0]);
    });
    setReportData(prev => ({
      ...prev,
      labels,
      values,
    }));
  }, []);
  let chart1_2_options = {
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    tooltips: {
      backgroundColor: "#f5f5f5",
      titleFontColor: "#333",
      bodyFontColor: "#666",
      bodySpacing: 4,
      xPadding: 12,
      mode: "nearest",
      intersect: 0,
      position: "nearest"
    },
    responsive: true,
    scales: {
      yAxes: [
        {
          barPercentage: 1.6,
          gridLines: {
            drawBorder: false,
            color: "rgba(29,140,248,0.0)",
            zeroLineColor: "transparent"
          },
          ticks: {

            padding: 20,
            fontColor: "#9a9a9a"
          }
        }
      ],
      xAxes: [
        {
          barPercentage: 1.6,
          gridLines: {
            drawBorder: false,
            color: "rgba(29,140,248,0.1)",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 20,
            fontColor: "#9a9a9a"
          }
        }
      ]
    }
  };




  let chartExample2 = {
    data: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
      gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

      return {
        labels: reportData.labels,
        datasets: [
          {
            label: "Data",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#1f8ef1",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#1f8ef1",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#1f8ef1",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: reportData.values
          }
        ]
      };
    },
    options: chart1_2_options
  };





















  // const data = {

  //   labels: reportData.labels,
  //   datasets: [
  //     {
  //       label: `${props.title} per day`,
  //       fill: true,
  //       // backgroundColor: gradientStroke,
  //       lineTension: 0.3,
  //       borderColor: "#35213d",
  //       pointBorderWidth: 1,
  //       pointHoverRadius: 5,
  //       pointHoverBackgroundColor: "#375751",
  //       pointHoverBorderColor: "rgba(220,220,220,1)",
  //       pointHoverBorderWidth: 2,
  //       pointRadius: 1,
  //       pointHitRadius: 10,
  //       data: reportData.values,
  //     },
  //   ],
  // };

  // const options = {
  //   scales: {
  //     yAxes: {
  //       suggestedMin: 0,
  //     },
  //     xAxes:
  //     {
  //       ticks: {
  //         autoSkip: true,
  //         maxTicksLimit: 7,
  //       },
  //     },
  //   },
  //   maintainAspectRatio: false,
  //   legend: {
  //     display: false,
  //   },
  //   plugins: {
  //     datalabels: {
  //       font: {
  //         size: 0,
  //       },
  //     },
  //   },
  // };

  useEffect(() => {
    const request = {

      client_id: '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',
      property_id: props.viewID,
      startDate,
      endDate,
      metrics: "activeUsers",
      dimensions: ['date'],
    };
    fetchData(request)
      .then((resp) => displayResults(resp))
      .catch((error) => console.error(error));
  }, [startDate, endDate, props.viewID, props.metric, fetchData, displayResults]);

  return (
    <Card className="card-chart shadow-lg border rounded">
      <CardHeader>
        <p className="card-category font-weight-bolder">{`${props.title} per day`}</p>
        <div className="d-flex justify-content-between">
          <div >
            <CustomDatePicker
              placeholder={"Start date"}
              date={startDate}
              handleDateChange={(date) => setStartDate(date)}
            />
          </div>
          <CustomDatePicker
            placeholder={"End date"}
            date={endDate}
            handleDateChange={(date) => setEndDate(date)}
          />
        </div>
        <CardTitle tag="h4">
        </CardTitle>

      </CardHeader>
      <CardBody>

        {reportData && (

          <div className="my-4 p-2">
            <Line data={chartExample2.data} options={chartExample2.options} height={300} />
          </div>

        )}
      </CardBody>
    </Card>

  );
};

export default DayVisitsReport;
